import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "q-pa-md q-card column justify-between",
  style: {"width":"700px","max-width":"80vw"}
}
const _hoisted_2 = { class: "q-gutter-md q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_billing_templates_form_field_delivery_policy_type = _resolveComponent("billing-templates-form-field-delivery-policy-type")!
  const _component_billing_templates_form_field_electronic_address = _resolveComponent("billing-templates-form-field-electronic-address")!
  const _component_billing_templates_form_field_electronic_operator = _resolveComponent("billing-templates-form-field-electronic-operator")!
  const _component_billing_templates_form_field_billing_email = _resolveComponent("billing-templates-form-field-billing-email")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_form, {
          greedy: "",
          onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
          ref: "form",
          class: "q-gutter-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_billing_templates_form_field_delivery_policy_type, {
              modelValue: _ctx.deliveryPolicyModel.deliveryPolicyType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deliveryPolicyModel.deliveryPolicyType) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.deliveryPolicyModel.deliveryPolicyType === 'electronic')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_billing_templates_form_field_electronic_address, {
                    modelValue: _ctx.deliveryPolicyModel.electronicAddress,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deliveryPolicyModel.electronicAddress) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_billing_templates_form_field_electronic_operator, {
                    modelValue: _ctx.deliveryPolicyModel.electronicOperatorId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deliveryPolicyModel.electronicOperatorId) = $event))
                  }, null, 8, ["modelValue"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.deliveryPolicyModel.deliveryPolicyType === 'email')
              ? (_openBlock(), _createBlock(_component_billing_templates_form_field_billing_email, {
                  key: 1,
                  modelValue: _ctx.deliveryPolicyModel.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deliveryPolicyModel.email) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "Save changes",
                type: "submit",
                "no-caps": "",
                unelevated: ""
              }),
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "Cancel",
                onClick: _ctx.onCancelClick,
                outline: "",
                "no-caps": ""
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}